
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    // AuctionsScreen
    title: 'Auctions',
    filtersAll: 'All',
    filtersActive: 'Active',
    filtersPending: 'Pending',
    filtersCompleted: 'Completed',
    emptyTitle: 'No Active Auctions',

    // AuctionDetailsScreen
    enterBidAmount: 'Enter bid amount',
    placeBid: 'Place Bid',
    placingBid: 'Placing Bid...',
    lastBidIsYours: 'You have the leading bid',
    bidsTitle: 'Bids',

    // Confirm bid popup
    confirmBidTitle: 'Confirm Bid',
    confirmBidMessage: 'You are about to place a bid of {{amount}} coins',
    confirmBidCancel: 'Cancel',
    confirmBidConfirm: 'Confirm',

    // Errors
    errorsLoading: 'Failed to load auctions',
    errorsLoadingDetails: 'Failed to load auction details',
    errorsNotFound: 'Auction not found',
    errorsPlacingBid: 'Failed to place bid',
    errorsBidTooLow: 'Bid must be higher than current bid',
    errorsCannotBidAgain: 'You cannot place consecutive bids',
    errorsInsufficientBalance: 'Insufficient balance',
  },
  ru: {
    // AuctionsScreen
    title: 'Аукционы',
    filtersAll: 'Все',
    filtersActive: 'Активные',
    filtersPending: 'Ожидают',
    filtersCompleted: 'Завершенные',
    emptyTitle: 'Нет активных аукционов',

    // AuctionDetailsScreen
    enterBidAmount: 'Введи сумму ставки',
    placeBid: 'Сделать ставку',
    placingBid: 'Размещение ставки...',
    lastBidIsYours: 'У тебя лидирующая ставка',
    bidsTitle: 'Ставки',

    // Confirm bid popup
    confirmBidTitle: 'Подтверждение ставки',
    confirmBidMessage: 'Ты собираешься сделать ставку на {{amount}} монет',
    confirmBidCancel: 'Отмена',
    confirmBidConfirm: 'Подтвердить',

    // Errors
    errorsLoading: 'Не удалось загрузить аукционы',
    errorsLoadingDetails: 'Не удалось загрузить детали аукциона',
    errorsNotFound: 'Аукцион не найден',
    errorsPlacingBid: 'Не удалось сделать ставку',
    errorsBidTooLow: 'Ставка должна быть выше текущей',
    errorsCannotBidAgain: 'Ты не можешь делать подряд две ставки',
    errorsInsufficientBalance: 'Недостаточно средств',
  },
  uz: {
    // AuctionsScreen
    title: 'Auktsionlar',
    filtersAll: 'Hammasi',
    filtersActive: 'Faol',
    filtersPending: 'Kutilmoqda',
    filtersCompleted: 'Tugagan',
    emptyTitle: "Faol auktsionlar yo'q",

    // AuctionDetailsScreen
    enterBidAmount: 'Taklif summasini kiriting',
    placeBid: 'Taklif berish',
    placingBid: 'Taklif berilmoqda...',
    lastBidIsYours: 'Sizda yetakchi taklif bor',
    bidsTitle: 'Takliflar',

    // Confirm bid popup
    confirmBidTitle: 'Taklifni tasdiqlash',
    confirmBidMessage: 'Siz {{amount}} tanga miqdorida taklif qilmoqchisiz',
    confirmBidCancel: 'Bekor qilish',
    confirmBidConfirm: 'Tasdiqlash',

    // Errors
    errorsLoading: "Auktsionlarni yuklab bo'lmadi",
    errorsLoadingDetails: "Auktsion tafsilotlarini yuklab bo'lmadi",
    errorsNotFound: 'Auktsion topilmadi',
    errorsPlacingBid: "Taklif berib bo'lmadi",
    errorsBidTooLow: "Taklif joriy narxdan yuqori bo'lishi kerak",
    errorsCannotBidAgain: 'Siz ketma-ket taklif bera olmaysiz',
    errorsInsufficientBalance: "Mablag' yetarli emas",
  },
});
